import styled from 'styled-components'
import { BookDefault } from '../../pages/PreviewPDF/createPdf/PdfBook'
import { CustomFont } from '../../pages/PreviewPDF/createPdf/types'
import { FormattedMessage, useIntl } from 'react-intl'
import { useCallback, useState } from 'react'
import { strings } from './BookBuilder.strings'
import { Button, Input } from '../atoms'
import { FontSelector } from '../molecules/selectors/FontSelector/FontSelector'

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1em;
`

export interface PageFormData {
  pageFont: CustomFont
  pageFontSize: number
  entriesPerPage: number
}

interface Props {
  bookSize: BookDefault
  initialValues?: PageFormData
  handleBack: () => void
  onSubmit: (data: PageFormData) => void
}

export const PageForm: React.FC<Props> = (props) => {
  const { onSubmit } = props
  const intl = useIntl()
  // const [coverImage, setCoverImage] = useState<File>()
  const [pageForm, setPageForm] = useState<PageFormData>({
    pageFont: props.initialValues?.pageFont ?? 'openSans',
    pageFontSize:
      props.initialValues?.pageFontSize ?? props.bookSize.page.fontSize,
    entriesPerPage:
      props.initialValues?.entriesPerPage ?? props.bookSize.entriesPerPage,
  })

  const handleSubmit = useCallback(
    (event: React.FormEvent<HTMLFormElement>) => {
      event.preventDefault()
      onSubmit(pageForm)
    },
    [pageForm, onSubmit],
  )

  return (
    <Form onSubmit={handleSubmit}>
      <h2>
        <FormattedMessage {...strings.pageHeading} />
      </h2>
      <FontSelector
        initialValue={pageForm.pageFont}
        onSelect={(selected) =>
          setPageForm({
            ...pageForm,
            pageFont: selected.value as CustomFont,
          })
        }
      />
      <Input
        label={intl.formatMessage(strings.pageFontSize)}
        type="number"
        min={12}
        max={42}
        step={2}
        value={pageForm.pageFontSize}
        onChange={(e) =>
          setPageForm({
            ...pageForm,
            pageFontSize: Number(e.target.value),
          })
        }
      />
      <Input
        label={intl.formatMessage(strings.entriesPerPage)}
        type="number"
        value={pageForm.entriesPerPage}
        min={1}
        // TODO: Need to think about this...
        max={3}
        onChange={(e) =>
          setPageForm({
            ...pageForm,
            entriesPerPage: Number(e.target.value),
          })
        }
      />
      <Button type="button" kind="secondary" onClick={() => props.handleBack()}>
        Back
      </Button>
      <Button type="submit" formMethod="post">
        Create
      </Button>
    </Form>
  )
}
